import { UserRoleType } from 'constants/userRoleType';
import { useAppSelector } from 'hooks/useSelector';

const useCanView = () => {
  const user = useAppSelector((store) => store.user);
  return (allowedUsers: typeof UserRoleType) => allowedUsers.includes(user.role.name);
};

export default useCanView;
